import React from 'react';
import { handleChange } from 'lib/stores/formStore';
import GenerateButton from 'lib/components/GenerateButton';
import ValidationStore from 'lib/stores/validationStore';

const ResidentGenerate = () => {
  const generate = () => {
    ValidationStore.update(state => {
      state.resident.dob = true;
      state.resident.family_name = true;
      state.resident.gender = true;
      state.resident.given_names = true;
    });

    handleChange('Test', 'resident.given_names');
    handleChange('Resident', 'resident.family_name');
    handleChange('01/01/1970', 'resident.dob');
    handleChange('Male', 'resident.gender');
  };

  return (
    <GenerateButton generate={generate} />
  );
};

export default ResidentGenerate;
